import { render, staticRenderFns } from "./Orthoptie.vue?vue&type=template&id=8154f2cc"
import script from "./Orthoptie.vue?vue&type=script&lang=js"
export * from "./Orthoptie.vue?vue&type=script&lang=js"
import style0 from "./Orthoptie.vue?vue&type=style&index=0&id=8154f2cc&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports